import api from "../../services/api";
import { types } from "../types/types";
import Constants from "../../services/constant";
import { showLoaderAction, hideLoaderAction } from "./loaderAction";
import { showToast } from "./toastAction";

const getTermsAndCondtions = (setData) => async (dispatch) => {
    dispatch(showLoaderAction());
    const res = await api("get", Constants.END_POINT.GET_TERMS_AND_CONDITIONS);
    if (res.success) {
        setData(res.data);
        if (res.data) {
            dispatch({
                type: types.TERMS_AND_CONDITIONS,
                payload: res.data,
            });
        }
    }
    dispatch(hideLoaderAction());
};

const updateTermsAndCondtions = (data, setData) => async (dispatch) => {
    dispatch(showLoaderAction());
    const res = await api("put", Constants.END_POINT.UPDATE_TERMS_AND_CONDITIONS + data._id, { ...data });
    if (res.success) {
        dispatch(hideLoaderAction());
        dispatch(showToast({ severity: "success", summary: res.message }));
        dispatch(getTermsAndCondtions(setData));
    } else {
        dispatch(showToast({ severity: "error", summary: res.message }));
    }
    dispatch(hideLoaderAction());
};

const getPrivacyPolicy = (setData) => async (dispatch) => {
    dispatch(showLoaderAction());
    const res = await api("get", Constants.END_POINT.GET_PRIVACY_POLICY);
    if (res.success) {
        setData(res.data);
        if (res.data) {
            dispatch({
                type: types.PRIVACY_POLICY,
                payload: res.data,
            });
        }
    }
    dispatch(hideLoaderAction());
};

const updatePrivacyPolicy = (data, setData) => async (dispatch) => {
    dispatch(showLoaderAction());
    const res = await api("put", Constants.END_POINT.UPDATE_PRIVACY_POLICY + data._id, { ...data });
    if (res.success) {
        dispatch(hideLoaderAction());
        dispatch(showToast({ severity: "success", summary: res.message }));
        dispatch(getPrivacyPolicy(setData));
    } else {
        dispatch(showToast({ severity: "error", summary: res.message }));
    }
    dispatch(hideLoaderAction());
};

const getFaqList = () => async (dispatch) => {
    dispatch(showLoaderAction());
    const res = await api("get", Constants.END_POINT.GET_FAQ);
    if (res.success) {
        if (res.data) {
            dispatch({
                type: types.FAQ,
                payload: res.data,
            });
        }
    }
    dispatch(hideLoaderAction());
};

const createFaq = (data, hideForm) => async (dispatch) => {
    dispatch(showLoaderAction());
    const res = await api("post", Constants.END_POINT.CREATE_FAQ, { ...data });
    if (res.success) {
        dispatch(hideLoaderAction());
        dispatch(showToast({ severity: "success", summary: res.message }));
        dispatch(getFaqList());
        hideForm(false);
    } else {
        dispatch(showToast({ severity: "error", summary: res.message }));
    }
    dispatch(hideLoaderAction());
};

const updateFaq = (data, hideForm) => async (dispatch) => {
    dispatch(showLoaderAction());
    const res = await api("put", Constants.END_POINT.UPDATE_FAQ + data._id, { ...data });
    if (res.success) {
        dispatch(hideLoaderAction());
        dispatch(showToast({ severity: "success", summary: res.message }));
        dispatch(getFaqList());
        hideForm(false);
    } else {
        dispatch(showToast({ severity: "error", summary: res.message }));
    }
    dispatch(hideLoaderAction());
};

const deleteFaq = (id) => async (dispatch) => {
    dispatch(showLoaderAction());
    const res = await api("delete", Constants.END_POINT.DELETE_FAQ + id);
    if (res.success) {
        dispatch(hideLoaderAction());
        dispatch(showToast({ severity: "success", summary: res.message }));
        dispatch(getFaqList());
    } else {
        dispatch(showToast({ severity: "error", summary: res.message }));
    }
    dispatch(hideLoaderAction());
};

export { getTermsAndCondtions, updateTermsAndCondtions, getPrivacyPolicy, updatePrivacyPolicy, getFaqList, createFaq, updateFaq, deleteFaq };
